import React, { Component } from 'react';

import classNames from 'classnames';
import { Drag } from 'components/drag';
import PropTypes from 'prop-types';

import SubtitleTimelineCueTab from './SubtitleTimelineCueTab';

import { CHANGE_TIME } from '../constants';
import SubtitleActions from '../SubtitleActions';
import SubtitleService from '../SubtitleService';

class SubtitleTimelineCue extends Component {
  static propTypes = {
    id: PropTypes.string,
    index: PropTypes.number,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    zoom: PropTypes.number,
    content: PropTypes.string,
    currentCue: PropTypes.object,
    onResizeCue: PropTypes.func,
    onMoveCue: PropTypes.func,
    onClose: PropTypes.func,
    onAdd: PropTypes.func
  };

  get cue() {
    const { startTime, endTime, content, index, id } = this.props;

    return { startTime, endTime, content, index, id };
  }

  isCurrentCueUpdated(nextCurrentCue = {}) {
    const { currentCue = {}, id } = this.props;

    return (
      currentCue.id !== nextCurrentCue.id &&
      (currentCue.id === id || nextCurrentCue.id === id)
    );
  }

  isCueUpdated(nextProps) {
    const { zoom, startTime, endTime, content } = this.props;

    return !(
      zoom === nextProps.zoom &&
      startTime === nextProps.startTime &&
      endTime === nextProps.endTime &&
      content === nextProps.content
    );
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.isCueUpdated(nextProps) ||
      this.isCurrentCueUpdated(nextProps.currentCue)
    );
  }

  render() {
    const { id, content, startTime, endTime, currentCue } = this.props;

    const isSelected = currentCue && currentCue.id === id;
    const className = classNames('subtitle__timeline__cue', {
      'subtitle__timeline__cue--selected': isSelected
    });

    const width = SubtitleService.convertSecondsToBasePixels(
      endTime - startTime
    );
    const left = SubtitleService.convertSecondsToBasePixels(startTime);

    const style = { width, left };

    return (
      <Drag onCueMove={this.onCueMove}>
        <div
          ref={(ref) => (this.timelineCue = ref)}
          onClick={this.setCurrentCue}
          className={className}
          style={style}
        >
          <SubtitleTimelineCueTab left onTabMove={this.tabMoveStart} />

          <div className="subtitle__timeline__cue__content">
            <span className="subtitle__timeline__cue__text _truncate-2">
              {content}
            </span>

            <div className="subtitle__timeline__cue__actions">
              <span
                className="subtitle__timeline__cue__button subtitle__timeline__cue__add"
                onClick={this.onAddNew}
              >
                {'+'}
              </span>
              <span
                className="subtitle__timeline__cue__button subtitle__timeline__cue__close"
                onClick={this.onClose}
              >
                {'✕'}
              </span>
            </div>
          </div>

          <SubtitleTimelineCueTab right onTabMove={this.tabMoveEnd} />
        </div>
      </Drag>
    );
  }

  tabMoveStart = (position) => {
    this.onChangeCueTime(position, CHANGE_TIME.START);
  };

  tabMoveEnd = (position) => {
    this.onChangeCueTime(position, CHANGE_TIME.END);
  };

  setCurrentCue = () => {
    SubtitleActions.setCurrentCue(this.cue);
  };

  onChangeCueTime = (position, type) => {
    const { onResizeCue } = this.props;
    const newPosition =
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      type === CHANGE_TIME.START ? position - 5 : position + 5;

    onResizeCue(newPosition, this.cue, type);
  };

  onCueMove = (pixelsMoved) => {
    const secondsMoved =
      SubtitleService.convertBasePixelsToSeconds(pixelsMoved);

    const startTime = this.cue.startTime + secondsMoved;
    const endTime = this.cue.endTime + secondsMoved;

    const initialCueDuration = endTime - startTime;

    const { onMoveCue } = this.props;

    onMoveCue &&
      onMoveCue({ ...this.cue, startTime, endTime }, initialCueDuration);
  };

  onClose = (event) => {
    event.stopPropagation();
    this.props.onClose && this.props.onClose(this.cue);
  };

  onAddNew = (event) => {
    event.stopPropagation();
    this.props.onAdd && this.props.onAdd(this.cue);
  };
}

export default SubtitleTimelineCue;
